import React, { useEffect } from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import './VideoVimeo.scss';

const VideoVimeo = ({ idvideo, overlayText, position = 'bottom' }) => {
    const { width: windowWidth } = useWindowDimensions();
    useEffect(() => {
        if (document.getElementById('vimeoScript') === null) {
            const scriptPlayer = document.createElement('script');
            scriptPlayer.src = 'https://player.vimeo.com/api/player.js';
            document.body.appendChild(scriptPlayer);
            // const script = document.createElement('script');
            // script.id = 'vimeoScript';
            // script.src = window.$pathBase + 'public/vimeoScript.min.js';
            // script.async = true;
            // document.body.appendChild(script);
            return () => {
                document.body.removeChild(scriptPlayer);
                // document.body.removeChild(script);
            };
        }
    }, []);
    return (
        <div className='embed-container link-wrap'>
            <div
                className={`video-overlay-container video-overlay-container-${position}`}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: overlayText,
                    }}></div>
            </div>
            <div className='blocker'></div>
            <iframe
                id='vimeo-video'
                src={`https://player.vimeo.com/video/${idvideo}?autoplay=1&loop=1&autopause=0&muted=1`}
                width={windowWidth}
                frameBorder='0'
                allow='autoplay'
                autoPlay
                muted></iframe>
        </div>
    );
};

export default VideoVimeo;
